<template>
  <div>
    <el-radio-group
      v-loading="requestLoading"
      :value="value"
      @input="changeHanlder"
    >
      <el-radio
        v-for="(item, index) in enumList"
        :key="index"
        :label="item.Name"
      >
        {{ item.Desc }}
      </el-radio>
    </el-radio-group>
  </div>
</template>
  
  <script>
export default {
  name: "EnumRadioGroup",
  props: {
    value: [String],
    enumName: [String],
  },
  data() {
    return {
      requestLoading: true,
      enumList: [],
    };
  },

  mounted() {
    this.flushEnum();
  },

  methods: {
    changeHanlder(val) {
      this.$emit("input", val);
      this.$emit("change", val);
    },
    async flushEnum() {
      if (this.enumName) {
        this.requestLoading = true;
        let requestRes = await this.$api.enumByName(this.enumName);
        if (requestRes && requestRes.success) {
          this.enumList = requestRes.data;
        }
        setTimeout(() => {
          this.requestLoading = false;
        }, 200);
      }
    },
  },
};
</script>
  
  <style scoped>
</style>


// WEBPACK FOOTER //
// src/components/qs/EnumRadioGroup.vue